import { render, staticRenderFns } from "./DashboardCalendar.vue?vue&type=template&id=6778020c&scoped=true&"
import script from "./DashboardCalendar.vue?vue&type=script&lang=ts&"
export * from "./DashboardCalendar.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardCalendar.vue?vue&type=style&index=0&id=6778020c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6778020c",
  null
  
)

export default component.exports